import React from "react";
import DashboardPart from "./DashbordPart";
import Pending from "../../Images/time-management.png";

const DashboardPending = ({ dashboardTotalInfo, isLoading }) => {

  return (
    <DashboardPart
      DashboardHeading="Total Pending Volunteer"
      DashboardValue={dashboardTotalInfo?.total_vol_pending}
      Icon={Pending}
      style={{ background: "linear-gradient(to right, #750504, #1565c0)" }}
      isLoading={isLoading}
    />
  );
};

export default DashboardPending;
